/*eslint-disable*/
import api from '../'

class TaskApi {
    // GET: task/:id
    static show(id) {
        return api.axios.get('/task/' + id)
            .then(response => response.data.tasks);
    }

    //GET: Tasks
    static list(cancelToken = null) {
        return api.axios.get('/task', {cancelToken})
            .then(response => {
                return response.data;
            })
    }

    //PUT: task/:id
    static update(id, task) {
        return api.axios.put('/task/' + id, task)
            .then(response => response.data.task)
    }

    // POST: task/:id
    static create(task) {
        return api.axios.post('/task', task)
            .then(response => response.data.task);
    }

    // DELETE: task/:id
    static delete(id) {
        return api.axios.delete('/task/' + id)
            .then(response => response.data);
    }

}

export default TaskApi;
